import React, { Component } from "react";
import { Router } from "react-router-dom";
// import { createBrowserHistory } from 'history';
import { ThemeProvider } from "@material-ui/styles";
//import validate from "validate.js";
import theme from "./theme";
// import "react-perfect-scrollbar/dist/css/styles.css";
//import "index.css";
import "./assets/scss/index.scss";
//import validators from "./common/validators";
import Routes from "./Routes";
import history from "./store/history/index";
import { Dashboard as DashboardView } from "./views";
import { Provider } from 'react-redux';
import store from './store';

// const browserHistory = createBrowserHistory();

// validate.validators = {
//   ...validate.validators,
//   ...validators,
// };

const EDI_App = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <DashboardView {...props} />
    </Provider>
  </ThemeProvider>
)

export default EDI_App;
